import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { DynamicButtonsComponent } from '../dynamic-buttons/dynamic-buttons.component';
import { DynamicGalleryComponent } from '../dynamic-gallery/dynamic-gallery.component';
import { DynamicImageComponent } from '../dynamic-image/dynamic-image.component';
import { DynamicPillsComponent } from '../dynamic-pills/dynamic-pills.component';
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component';
import { UserMessageComponent } from '../user-message/user-message.component';
import { DynamicVideoComponent } from '../dynamic-video/dynamic-video.component';
import { DynamicAlertComponent } from '../dynamic-alert/dynamic-alert.component';
import { CommonModule } from '@angular/common';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-message-response',
  templateUrl: './message-response.component.html',
  styleUrls: ['./message-response.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    DynamicButtonsComponent,
    DynamicPillsComponent,
    DynamicGalleryComponent,
    DynamicImageComponent,
    DynamicTextComponent,
    UserMessageComponent,
    DynamicVideoComponent,
    DynamicAlertComponent,
  ],
})
export class MessageResponseComponent implements OnInit {
  @Input() message: any;
  @Input() lastMessage: boolean = false;
  @Input() canSendMessage: boolean = true;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();

  constructor(private chatService: ChatService) {}

  isHovered = false;

  get configs() {
    return this.chatService.configs;
  }

  type: string = 'NA';

  ngOnInit() {
    this.type = this.message?.content?.type;
    if (this.message?.content?.message_text) {
      this.message.content.message_text =
        this.message.content.message_text.replaceAll('\n', '<br>');
    }
  }

  getMessageStyles() {
    const isUser = this.message.type === 'user';

    return {
      'background-color': isUser
        ? this.configs?.colors?.user_message_background
        : this.configs?.colors?.bot_message_background,
      color: isUser
        ? this.configs?.colors?.user_message_text
        : this.configs?.colors?.bot_message_text,
      border: `1px solid ${this.configs?.colors?.bot_message_border}`,
    };
  }
}
